import * as React from "react";
import useAppContextRole from "../../app-context/useAppContextRole";

import useListVideos from "../../hooks/videos/useListVideos";
import { Video, AppContextRole } from "../../types";

import Card from "../common/Card";
import Layout from "../common/Layout";
import List, { ListProps } from "../common/List";
import Button from "../common/PressableButton";
import Text from "../common/Text";

import CreateOrUpdateVideo from "./CreateOrUpdateVideo";
import VideoOne from "./VideoOne";

export interface VideoGridProps {
  videos?: Video[];
  emptyText?: string;
}

function VideoGrid({ videos, emptyText = "No videos" }: VideoGridProps) {
  const videosQuery = useListVideos({ enabled: !videos });

  const VideoList = React.useCallback(
    (props: Pick<ListProps, "renderEmpty" | "renderItem">) => {
      if (videos) {
        return (
          <List<Video> {...props} getKey={(item) => item.id} items={videos} />
        );
      }

      return <List.Async<Video> {...videosQuery} {...props} />;
    },
    [videos, videosQuery]
  );

  const [role] = useAppContextRole();

  return (
    <Layout.Grid fullWidth size={0.5}>
      <VideoList
        renderEmpty={() => (
          <Layout.Box greedy>
            <Text textAlign="center">{emptyText}</Text>
          </Layout.Box>
        )}
        renderItem={({ item }: { item: Video; index: number }) => (
          <Layout.Box size={0.5}>
            <Card>
              <CreateOrUpdateVideo
                id={item.id}
                disabled={role === AppContextRole.Learner}
              >
                {({ onPress, disabled }) => (
                  <Button onPress={onPress} disabled={disabled}>
                    <Layout.Box size={1}>
                      <VideoOne video={item} />
                    </Layout.Box>
                  </Button>
                )}
              </CreateOrUpdateVideo>
            </Card>
          </Layout.Box>
        )}
      />
    </Layout.Grid>
  );
}

export default VideoGrid;
